import type { CrossDomainFinding, Finding } from '@/model/Agent.model';
import { _isNil } from '@/littledash';
import type { FC } from 'react';
import { SEVERITY_SOURCE_TEXT, severitySourceOf } from '@/components/Agents/SendValidator/utils/sendSeverity';
import styles from './sendResults.module.scss';

interface SendSeveritySourceProps {
  finding: Finding | CrossDomainFinding;
}

/**
 * Who graded a finding, beside its severity, so a grade we derived is never read as a regulator's. No
 * published grading exists for SEND in M1, so every grade says it is ours. Renders nothing for a finding
 * stored before its source was recorded.
 */
const SendSeveritySource: FC<SendSeveritySourceProps> = ({ finding }) => {
  const source = severitySourceOf(finding);
  if (_isNil(source)) {
    return null;
  }
  const { label, title } = SEVERITY_SOURCE_TEXT[source];
  return (
    <span className={styles.cellNote} title={title} data-test-element="severity-source" data-test-key={source}>
      {label}
    </span>
  );
};

export default SendSeveritySource;
